import { animate, state, style, transition, trigger } from '@angular/animations';
import { AdminScopes } from '@app/shared/services/admin-scopes';

export enum Roles {
  USER = 'U',
  ADMINISTRATOR = 'A',
  OWNER = 'O', // formerly 'root'
  MACHOOL = 'M',
  SUPPORT = 'S',
}

export enum RolesVerbose {
  USER = 'User',
  ADMINISTRATOR = 'Admin',
  OWNER = 'Owner',
  MACHOOL = 'Customer support',
  SUPPORT = 'Support User',
}

export enum SupportClaimStatus {
  UNRESOLVED = 'Unresolved',
  ALL_RESOLVED = 'All Resolved',
  OPEN = 'Open',
  IN_PROGRESS = 'In Progress',
  ESCALATED = 'Escalated',
  READY_FOR_FINANCE = 'Ready for finance',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
}

export enum WalletTransactionTypes {
  SHIPMENT_CHARGE = 'Shipment Charge',
  RECON_CHARGE = 'Recon Charge',
  FUNDS_ADDED = 'Funds Added',
  ADMIN_ADJUSTMENT = 'Administrative Adjustment',
}

export enum BillingTypes {
  CREDIT_CARD = 'C',
  MACHOOL_ACCOUNT = 'M',
  MACHOOL_WALLET = 'W',
  THIRDPARTY_ACCOUNT = 'THIRDPARTY',
}

export enum BillingTypesVerbose {
  CREDIT_CARD = 'Credit card',
  MACHOOL_ACCOUNT = 'Machool account',
  MACHOOL_WALLET = 'Machool Wallet',
  THIRDPARTY_ACCOUNT = 'Bill to 3rd party account',
}

export enum AccountCategory {
  BUSINESS = 'Business',
  PERSONAL = 'Personal',
}

export enum CompanyNoteType {
  HAPPY = 'H',
  NEUTRAL = 'N',
  UNHAPPY = 'U',
  CONFUSED = 'C',
}

export enum CompanyNoteVerbose {
  HAPPY = 'Happy',
  NEUTRAL = 'Neutral',
  UNHAPPY = 'Unhappy',
  CONFUSED = 'Confused',
}

// Company Enums
export enum PricingTiers {
  BRONZE = 'B',
  SILVER = 'S',
  GOLD = 'G',
  EMPLOYEE = 'E',
  CORPORATE = 'C',
  AFFINITY_CQCD = 'Q',
  AFFINITY_RCC = 'R',
  AFFINITY_SHIPALBERTA = 'A',
  PERSONAL = 'Z',
}

export enum PricingTierVerbose {
  BRONZE = 'Bronze',
  SILVER = 'Silver',
  GOLD = 'Gold',
  CORPORATE = 'Custom',
  AFFINITY_CQCD = 'CQCD',
  EMPLOYEE = 'Employee',
  AFFINITY_RCC = 'RCC',
  AFFINITY_SHIPALBERTA = 'ShipAlberta',
  PERSONAL = 'Personal',
}

export enum SupportedReconProvider {
  PUROLATOR = 'PUROLATOR',
  DHL = 'DHL',
  GLS = 'GLS',
  NATIONEX = 'NATIONEX',
  LIVRAPIDE = 'LIVRAPIDE',
  CANPAR = 'CANPAR',
  FEDEX = 'FEDEX',
  RIVO = 'RIVO',
  MULTILEG = 'MULTILEG',
  CANADA_POST = 'CANADA_POST',
  CANADA_POST_3PL = 'CANADA_POST_3PL',
  CHASSEURS_COURRIER = 'CHASSEURS_COURRIER',
  UNIUNI = 'UNIUNI',
  FLASHBOX = 'FLASHBOX',
  INTELCOM_MULTI_LEG = 'INTELCOM_MULTI_LEG',
  APPLE_EXPRESS_MULTI_LEG = 'APPLE_EXPRESS_MULTI_LEG',
  UPS = 'UPS',
  UNIUNI_MULTI_LEG = 'UNIUNI_MULTI_LEG',
  POSTNL_UNIUNI = 'POSTNL_UNIUNI',
  T_FORCE_MULTI_LEG = 'T_FORCE_MULTI_LEG',
  ICS_COURIER = 'ICS_COURIER',
  UBER = 'UBER',
  COURANT_PLUS = 'COURANT_PLUS',
  GOBOLT = 'GOBOLT',
  DELIVRO = 'DELIVRO',
  DAYROSS = 'DAYROSS',
  UPIC = 'UPIC',
  MARSH = 'MARSH',
  LOOMIS_EXPRESS = 'LOOMIS_EXPRESS',
  FREIGHT_GLS = 'FREIGHT_GLS',
  FREIGHT_AIR_CANADA = 'FREIGHT_AIR_CANADA',
  CHRONO_EXPRESS = 'CHRONO_EXPRESS',
}

export enum ShippingProviders {
  CANPAR = 'canpar',
  CHASSEURS_COURRIER = 'chasseurscourrier',
  CANADA_POST = 'canadapost',
  CANADA_POST_3PL = 'canadapost3pl',
  DHL = 'dhl',
  GLS = 'gls',
  INTELCOM = 'intelcom',
  FEDEX = 'fedex',
  FLASHBOX = 'flashbox',
  FEDEX_GROUND = 'fedexGround',
  FEDEX_EXPRESS = 'fedexExpress',
  PUROLATOR = 'purolator',
  UPS = 'ups',
  MACHOOL = 'machool',
  NATIONEX = 'nationex',
  SHIFT = 'shift',
  EEKO = 'eeko',
  RIVO = 'rivo', // Air Canada
  MULTILEG = 'multileg',
  AIR_CANADA_DOMESTIC = 'aircanadadomestic', // Air Canada domestic
  AIR_CANADA_INTERNATIONAL = 'aircanadainternational', // Air Canada international
  UNIUNI = 'uniuni',
  SPRING = 'spring',
  TREXITY = 'trexity',
  TFORCE_LOGISTICS = 'tforcelogistics',
  MACHOOL_LOGISTICS = 'machoollogistics',
  APPLE_EXPRESS = 'appleexpress',
  LIVRAPIDE = 'livrapide',
  ICS_COURIER = 'icscourier',
  EVA = 'eva',
  DELIVRO = 'delivro',
  DEELEEO = 'deeleeo',
  ULALA = 'ulala',
  MDX = 'mdx',
  LOOMIS_EXPRESS = 'loomisexpress',
  GOBOLT = 'gobolt',
  COURANT_PLUS = 'courantplus',
  UBER = 'uber',
  CHRONO_EXPRESS = 'chronoexpress',
  ZIPPLY = 'zipply',

  // Freight couriers
  FREIGHT_AIR_CANADA = 'freightaircanada',
  DAYROSS = 'dayross',
  FREIGHT_GLS = 'freightgls',
  GROUPE_MORNEAU = 'groupemorneau',
  CARGOJET = 'cargojet',
  FREIGHT_PUROLATOR = 'freightpurolator',
}

export enum FREIGHT_PROVIDERS {
  DAYROSS = 'dayross',
  FREIGHT_GLS = 'freightgls',
  GROUPE_MORNEAU = 'groupemorneau',
  CARGOJET = 'cargojet',
  FREIGHT_PUROLATOR = 'freightpurolator',
}

export enum ShippingProviderNames {
  AIR_CANADA = 'MultiLeg (Legacy)',
  CANADA_POST = 'Canada Post',
  CANADA_POST_3PL = 'Canada Post 3PL',
  CANPAR = 'Canpar Express',
  CHASSEURS_COURRIER = 'Chasseurs Courrier',
  GLS = 'GLS',
  DHL = 'DHL',
  FEDEX = 'FedEx®',
  FEDEX_EXPRESS = 'FedEx Express',
  FEDEX_GROUND = 'FedEx Ground',
  FLASHBOX = 'FlashBox',
  INTELCOM = 'Dragonfly',
  NATIONEX = 'Nationex',
  PUROLATOR = 'Purolator',
  SHIFT = 'Shift Delivery',
  UPS = 'UPS®',
  EEKO = 'EEKO',
  RIVO = 'Rivo',
  MULTILEG = 'MultiLeg',
  AIR_CANADA_DOMESTIC = 'MultiLeg (Domestic)',
  AIR_CANADA_INTERNATIONAL = 'MultiLeg (International)',
  UNIUNI = 'UniUni',
  SPRING = 'Spring',
  MACHOOL = 'Machool',
  TREXITY = 'Trexity',
  APPLE_EXPRESS = 'Apple Express',
  TFORCE_LOGISTICS = 'TForce',
  MACHOOL_LOGISTICS = 'Machool Logistics',
  LIVRAPIDE = 'Livrapide',
  ICS_COURIER = 'ICS Courier',
  EVA = 'Eva',
  DELIVRO = 'Delivro',
  DEELEEO = 'Deeleeo',
  ULALA = 'Ulala',
  MDX = 'MDX Logistique',
  LOOMIS_EXPRESS = 'Loomis Express',
  CHRONO_EXPRESS = 'ChronoExpress',
  ZIPPLY = 'Zipply',
  UNKNOWN = 'N/A',
  GOBOLT = 'GoBolt',
  COURANT_PLUS = 'Courant Plus by Nationex',
  UBER = 'Uber',
  DAYROSS = 'Day & Ross',
  FREIGHT_GLS = 'GLS Freight',
  CARGOJET = 'Cargojet',
  // Freight Air Canada Cargo
  FREIGHT_AIR_CANADA = 'Air Canada Cargo (Freight)',
  // Recon Providers
  UNIUNI_MULTI_LEG = 'UniUni (MultiLeg)',
  POSTNL_UNIUNI = 'UniUni (PostNL)',
  INTELCOM_MULTI_LEG = 'Dragonfly (MultiLeg)',
  APPLE_EXPRESS_MULTI_LEG = 'Apple Express (MultiLeg)',
  T_FORCE_MULTI_LEG = 'TForce (MultiLeg)',
  GROUPE_MORNEAU = 'Groupe Morneau',
  FREIGHT_PUROLATOR = 'Purolator Freight',
}

export enum DeliveryToPickupLocationProviders {
  PENGUIN_PICKUP = 'penguinpickup',
  PUDO = 'pudo',
}

export enum DeliveryToPickupLocationProviderNames {
  PENGUIN_PICKUP = 'PenguinPickUp',
  PUDO = 'PUDO',
}

export const CacheKeys = {
  INVOICES_LAST_INVOICE_NUMBER: 'invoices:last-invoice-number',
};

export const Mailers = {
  SEND_CUSTOMER_INVOICE: 'sendCustomerInvoice',
};

export enum InvoiceDownloadTypes {
  PDF = 'pdf',
  CSV = 'csv',
}

export const PUBLIC_INVOICES_URL_PATH = 'statements/invoices/download';

export enum PaymentTypes {
  E_TRANSFER = 'E',
  EFT = 'F',
  CHEQUE = 'C',
}

export enum PaymentTypesVerbose {
  E_TRANSFER = 'E-transfer',
  EFT = 'EFT',
  CHEQUE = 'Cheque',
}

export enum ProviderNotificationCapabilities {
  IS_EDITABLE_RECIPIENT = 1, // 0001
  DEFAULT_ON_RECIPIENT = 2, // 0010
  IS_EDITABLE_SENDER = 4, // 0100
  DEFAULT_ON_SENDER = 8, // 1000
  IS_EDITABLE_PICKUP = 16, // 0001 0000
  DEFAULT_ON_PICKUP = 32, // 0010 0000
}

export enum ShipmentStatuses {
  CREATED = 'CR',
  CONFIRMED = 'CF',
  CANCELLED = 'CL',
  UNCONFIRMED = 'UC',
  PENDING_CANCEL = 'PC',
  CANCEL_REJECTED = 'CJ',
  PARTIALLY_DELIVERED = 'PD',
}

export enum ShipmentStatusesVerbose {
  CREATED = 'Confirmed',
  CONFIRMED = 'Confirmed',
  CANCELLED = 'Cancelled',
  UNCONFIRMED = 'Unconfirmed',
  PENDING_CANCEL = 'Cancel pending',
  CANCEL_REJECTED = 'Cancel rejected',
  PARTIALLY_DELIVERED = 'Partially Delivered',
  DELIVERED = 'Delivered',
  ATTENTION = 'Attention',
  IN_TRANSIT = 'In-transit',
  UNKNOWN = 'Unknown',
}

export enum ThirdPartyInsuranceProviderStatus {
  BOOKED = 'BOK', // When a shipment is insurable
  CANCEL_PENDING = 'CCP',
  REFERRED = 'REF', // When a shipment must be reviewed by an underwriter
  CANCELLED = 'CAN',
  REJECTED = 'REJ',
}

export enum LegacyShipmentStatuses {
  // internal statuses
  CREATED = 'created',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  UNCONFIRMED = 'unconfirmed',
  PENDING_CANCEL = 'pendingCancel',
  CANCEL_REJECTED = 'cancelRejected',
  // tracking statuses
  TRACKING_DELIVERED = 'delivered',
  TRACKING_IN_TRANSIT = 'in-transit',
  TRACKING_LOCAL_BRANCH = 'local-branch',
  TRACKING_ATTENTION = 'attention',
  PARTIALLY_DELIVERED = 'partially-delivered',
}

export enum ShipmentChargeStatus {
  CHARGE_PENDING = 'CP',
  CHARGE_DECLINED = 'CD',
  CHARGE_APPROVED = 'CA',
  REFUND_PENDING = 'RP',
  REFUND_DECLINED = 'RD',
  REFUND_APPROVED = 'RA',
  ADJUSTMENT_PENDING = 'AP',
  ADJUSTMENT_DECLINED = 'AD',
  ADJUSTMENT_APPROVED = 'AA',
  ADJUSTMENT_IGNORED = 'AI',
  UNKNOWN_REASON = 'UR',
  DO_NOT_BILL_ADJUSTMENTS = 'DB',
}

export enum ReconciliationFilterStatus {
  NEEDS_ATTENTION = 'needs_attention',
  PENDING_LIGHT = 'pending_light',
  ANY = 'any',
}

export enum ReconciliationFilterStatusVerbose {
  NEEDS_ATTENTION = 'Needs attention',
  PENDING_LIGHT = 'Pending (light)',
  ANY = 'Any',
}

// TODO: use @machool/common [last validated 2026-10-16]
export enum InsuranceProviders {
  MARSH = 'marsh',
  UPIC = 'upic',
}

export enum InsuranceProviderNames {
  MARSH = 'MARSH',
  UPIC = 'UPIC',
  UNKNOWN = 'N/A',
}

export enum RefundMethods {
  WALLET = 'Machool Wallet / Credit Note',
  E_TRANSFER = 'E-Transfer',
}

export enum EcommerceProviders {
  SHOPIFY = 'shopify',
  LIGHTSPEED = 'lightspeed',
  WOOCOMMERCE = 'woocommerce',
  MAGENTO = 'magento',
  WIX = 'wix',
  ETSY = 'etsy',
  BIGCOMMERCE = 'bigcommerce',
  DVORE = 'dvore',
  SQUARESPACE = 'squarespace',
  PANIERDACHAT = 'panierdachat',
  TECHPOS = 'techpos',
  XCART = 'xcart',
  LEPANIERBLEU = 'lepanierbleu',
  LIGHTSPEED_E_SERIES = 'lightspeedeseries',
}

export enum EcommerceProviderNames {
  SHOPIFY = 'Shopify',
  LIGHTSPEED = 'Lightspeed',
  WOOCOMMERCE = 'WooCommerce',
  MAGENTO = 'Magento',
  WIX = 'Wix',
  ETSY = 'Etsy',
  BIGCOMMERCE = 'BigCommerce',
  DVORE = 'Dvore',
  SQUARESPACE = 'Squarespace',
  PANIERDACHAT = 'Panierdachat',
  TECHPOS = 'TechPOS',
  XCART = 'X-Cart',
  LEPANIERBLEU = 'LePanierBleu',
  LIGHTSPEED_E_SERIES = 'Lightspeed E-Series',
}

export enum TrackingTypes {
  FORWARD = 'forward',
  RETURN = 'return',
  PIECE = 'piece',
}

export enum DateFormats {
  DATE = 'EEEE, d LLLL',
  DATE_SHORT_MONTH = 'EEEE, d LLL',
  DATE_SHORT = 'EEE, d LLL',
  DATE_MONTH = 'd LLLL',
  DATE_MONTH_SML = 'd LLL',
  DATE_DAY = 'd',
  DATE_ISO = 'yyyy-MM-dd',
  DATE_ISO_FULL = 'yyyy-MM-ddThh:mm:ssZ',
  DATE_YEAR_SML = 'd LLL, yyyy',
  DATE_YEAR = 'd LLLL, yyyy',
  DATE_TIME = 'EEEE, LLLL d h:mma',
  DELIVERY_DATE_TIME = "EEEE, LLLL d, yyyy 'at' h:mm a",
  DATE_TIME_YEAR = 'd LLLL h:mma yyyy',
  DATE_TIME_SHIPMENT = 'LLL d, h:mm a',
  TIME = 'h:mm a',
  WEEKDAY = 'EEEE',
  ORDER_LIST = 'MM/dd h:mma',
}

export const MIN_MARKUP_VALUE = -10; // shared min for both %
export const MAX_MARKUP_PERCENT = 100;
export const MAX_MARKUP_DOLLAR = 1000;

export enum AccountTypes {
  MACHOOL = 'M',
  BYOA = 'B',
}

export enum AccountTypesForOTP {
  MACHOOL = 'M',
  BYOA = 'B',
  ALL = 'A',
}

export enum ShipmentType {
  MANUAL = 'manual',
  ECOM = 'ecom',
  BULK = 'bulk',
  API = 'api',
}

export enum AccountTypesVerbose {
  MACHOOL = 'Machool',
  BYOA = 'BYOA',
}

export const TRACKING_TIMESTAMP_FORMAT = 'yyyy-MM-dd HH:mm';
export const TRACKING_TIMESTAMP_EXT_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export enum ShipmentStatus {
  AWAITINGPU = 'Awaiting pickup',
  DELIVERED = 'Delivered',
  ESTIMATED = 'estimated delivery',
  INTRANSIT = 'Item in transit',
  LOCALBRANCH = 'At local branch',
  LOCATION = 'last location',
  NOTRACKING = 'No tracking information available at the moment',
  NUMBER = 'tracking number',
  SHIPMENT_INFO_RECEIVED = 'Shipment information received',
  STATUS = 'Status',
  TITLE = 'tracking information',
  TRACK_ERROR = 'Not Available',
  PARTIALLY_DELIVERED = 'Partially Delivered',
}

export enum ErrorMessages {
  UNAUTHORIZED = 'You are unauthorized to access this resource',
  UNEXPECTED = 'There was an unexpected error, please try again or contact support',
  TIMEOUT = 'Request timed out',
}

export const Animations = {
  ReconExpandAnimation: trigger('detailExpand', [
    state('collapsed', style({ maxHeight: '0px', height: '0px', minHeight: '0' })),
    state('expanded', style({ height: '*' })),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
  ExpandAnimation: trigger('detailExpand', [
    state('collapsed', style({ maxHeight: '0px', height: '0px', minHeight: '0' })),
    state('expanded', style({ height: '*', maxHeight: '1000px' })),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
  OpenClose: trigger('openClose', [
    // ...
    state(
      'open',
      style({
        'margin-left': '290px',
      }),
    ),
    state(
      'closed',
      style({
        'margin-left': '100px',
      }),
    ),
    transition('open => closed', [animate('0.25s ease-in-out')]),
    transition('closed => open', [animate('0.25s ease-in-out')]),
  ]),
  RotateIcon: trigger('rotateIcon', [
    // ...
    state(
      'open',
      style({
        rotate: '0deg',
      }),
    ),
    state(
      'closed',
      style({
        rotate: '180deg',
      }),
    ),
    transition('open => closed', [animate('0.25s ease-in-out')]),
    transition('closed => open', [animate('0.25s ease-in-out')]),
  ]),
};

export interface sidenavItems {
  routerLink: string;
  iconType?: string;
  icon: string;
  title: string;
  pageTitle?: string;
  active: boolean;
  scope: AdminScopes[];
  preventScope?: AdminScopes[];
  iconClass?: string;
  withSpacer?: boolean;
}

export enum EDI_INVOICE_MODAL_TYPE {
  UNKNOWN_TRACKING = 'unknown-tracking-info',
  EDI_INVOICE_ONLY = 'edi-invoice-only',
}

export const DEFAULT_LOCALE = 'en-CA';

export enum ReportCardGroup {
  ACCOUNTS = 'accounts',
  NEW_ACCOUNTS = 'new_accounts',
  STARTED_SHIPPING = 'started_shipping',
  GREEN_SHIPMENTS_REVENUE = 'green_shipments_revenue',
  STRIPE = 'stripe',
  RECON_ADJUSTMENTS = 'recon_adjustments',
  CQCD = 'cqcd',
  SHIP_ALBERTA = 'ship_alberta',
  RCC = 'rcc',
  SIGNE_LOCAL = 'signe_local',
  PANIER_DA_CHAT = 'panier_da_chat',
  NATIONEX_PICKUP = 'nationex_pickup',
  WALLET_BALANCE = 'wallet_balance',

  SHIPMENTS = 'shipments',
  SHIPMENTS_MANUAL = 'shipments_manual',
  SHIPMENTS_ECOMMERCE = 'shipments_ecommerce',
  SHIPMENTS_API = 'shipments_api',
  SHIPMENTS_CONNECT = 'shipments_connect',
  SHIPMENTS_FREIGHT = 'shipments_freight',
  REVENUE = 'revenue',
  REVENUE_BY_CHARGE = 'revenue_by_charge',
  REVENUE_BY_BYOA = 'revenue_by_byoa',
  LOYALTY_REWARDS = 'loyalty_rewards',

  TOP_REVENUE = 'top_revenue',
  TOP_COURIERS = 'top_couriers',

  ACC_SHIPMENTS = 'acc_shipments',
}

export enum ReportCardNames {
  ACCOUNTS = 'ALL ACCOUNTS',
  NEW_ACCOUNTS = 'NEW SIGNUPS',
  STARTED_SHIPPING = 'STARTED SHIPPING',
  REVENUE = 'REVENUE (by ship date)',
  REVENUE_BY_CHARGE = 'REVENUE (by charge date)',
  GREEN_SHIPMENTS_REVENUE = 'GREEN SHIPMENTS REVENUE',
  STRIPE = 'STRIPE',
  RECON_ADJUSTMENTS = 'RECON ADJUSTMENTS',
  CQCD = 'CQCD',
  SHIP_ALBERTA = 'ShipAlberta',
  RCC = 'RCC',
  SIGNE_LOCAL = 'SIGNÉ LOCAL',
  PANIER_DA_CHAT = 'PANIERDACHAT',
  WALLET_BALANCE = 'Machool Wallet',
  REVENUE_BY_BYOA = 'BYOA REVENUE',
  SHIPMENTS = 'SHIPMENTS - ALL',
  SHIPMENTS_MANUAL = 'SHIPMENTS - MANUAL',
  SHIPMENTS_ECOMMERCE = 'SHIPMENTS - E-COM',
  SHIPMENTS_API = 'SHIPMENTS - API',
  SHIPMENTS_CONNECT = 'SHIPMENTS - BULK SHIP',
  SHIPMENTS_FREIGHT = 'SHIPMENTS - FREIGHT',
  LOYALTY_REWARDS = 'LOYALTY REWARDS',

  UNKNOWN = 'UNKNOWN',
}

export enum InvoicePaymentTypes {
  PAD = 'PAD',
  CREDIT_CARD = 'CREDIT_CARD',
  OTHER = 'OTHER',
}

export const PanelWidths = {
  desktopFull: '600px',
  mobileFull: '100vw',
};

export enum CompanyChargeName {
  MACHOOL = 'machool',
  CUSTOMER = 'customer',
}

export enum BillingName {
  CREDIT_CARD = 'credit-card',
  MACHOOL_ACCOUNT = 'machool-account',
  MACHOOL_WALLET = 'machool-wallet',
}

export enum CompanyChargeCode {
  PICKUP_FEE = 'pickup-fee',
  PICKUP_FEE_WITHOUT_SHIPMENT = 'pickup-fee-without-shipment',
  STORE_PURCHASE = 'supply-store',
  API_SUBSCRIPTION = 'api-subscription',
  ADDRESS_CORRECT = 'address-correction',
  ECOMMERCE_PLUGIN = 'ecommerce-plugin',
  RETURN_CENTRE = 'return-centre',
  LOYALTY_REWARD = 'loyalty-reward',
  FIRST_MILE_PICKUP_FEE = 'first-mile-pickup-fee',
}

export const ResponsiveRanges = {
  mobile: 768,
  desktop: 992,
  largeDesktop: 1200,
};

export const SupportedAirports = [
  {
    code: 'YYZ',
    name: 'Toronto Pearson International Airport',
    address: {
      line1: '2580 Britannia Road East',
      line2: '',
      city: 'Mississauga',
      province: 'ON',
      country: 'CA',
      postalCode: 'L4W 2P7',
      timezone: 'America/Toronto',
    },
    formattedAddress: {
      firstLine: '2580 Britannia Road East',
      secondLine: 'Mississauga, ON, L4W 2P7, CA',
    },
  },
  {
    code: 'YUL',
    name: 'Montréal-Pierre Elliott Trudeau International Airport',
    address: {
      line1: '2200 Reverchon',
      line2: 'Dock Door #43',
      city: 'Dorval',
      province: 'QC',
      country: 'CA',
      postalCode: 'H9P 2S7',
      timezone: 'America/Toronto',
    },
    formattedAddress: {
      firstLine: '2200 Reverchon',
      secondLine: 'Dorval, QC, H9P 2S7, CA',
    },
  },
  {
    code: 'YOW',
    name: 'Ottawa International Airport',
    address: {
      line1: '900 Airport Parkway Private',
      line2: '',
      city: 'Ottawa',
      province: 'ON',
      country: 'CA',
      postalCode: 'K1V 9B4',
      timezone: 'America/Toronto',
    },
    formattedAddress: {
      firstLine: '900 Airport Parkway Private',
      secondLine: 'Ottawa, ON, K1V 9B4, CA',
    },
  },
  {
    code: 'YQB',
    name: 'Quebec City Jean Lesage International Airport',
    address: {
      line1: "230-C, 2 eme Ave. de l'Aeroport",
      line2: '',
      city: 'Quebec',
      province: 'QC',
      country: 'CA',
      postalCode: 'G2G 2T2',
      timezone: 'America/Toronto',
    },
    formattedAddress: {
      firstLine: "230-C, 2 eme Ave. de l'Aeroport",
      secondLine: 'Quebec, QC, G2G 2T2, CA',
    },
  },
  {
    code: 'YVR',
    name: 'Vancouver International Airport',
    address: {
      line1: '4900 Miller Road',
      line2: '',
      city: 'Richmond',
      province: 'BC',
      country: 'CA',
      postalCode: 'V7B 1K7',
      timezone: 'America/Vancouver',
    },
    formattedAddress: {
      firstLine: '4900 Miller Road',
      secondLine: 'Richmond, BC, V7B 1K7, CA',
    },
  },
  {
    code: 'YEG',
    name: 'Edmonton International Airport',
    address: {
      line1: '3996 21 Street East',
      line2: '',
      city: 'Edmonton',
      province: 'AB',
      country: 'CA',
      postalCode: 'T9E 0V6',
      timezone: 'America/Edmonton',
    },
    formattedAddress: {
      firstLine: '3996 21 Street East',
      secondLine: 'Edmonton, AB, T9E 0V6, CA',
    },
  },
  {
    code: 'YYC',
    name: 'Calgary International Airport',
    address: {
      line1: '175 Aero Way NE',
      line2: '#110',
      city: 'Calgary',
      province: 'AB',
      country: 'CA',
      postalCode: 'T2E 6K2',
      timezone: 'America/Edmonton',
    },
    formattedAddress: {
      firstLine: '#110-175 Aero Way NE',
      secondLine: 'Calgary, AB, T2E 6K2, CA',
    },
  },
  {
    code: 'YQR',
    name: 'Regina International Airport',
    address: {
      line1: '3010 Tutor Drive',
      line2: '#400',
      city: 'Regina',
      province: 'SK',
      country: 'CA',
      postalCode: 'S4W 0R7',
      timezone: 'America/Regina',
    },
    formattedAddress: {
      firstLine: '#400 3010 Tutor Drive',
      secondLine: 'Regina, SK, S4W 0R7, CA',
    },
  },
  {
    code: 'YXE',
    name: 'Saskatoon John G. Diefenbaker International Airport',
    address: {
      line1: '2605 Airport Road',
      line2: '',
      city: 'Saskatoon',
      province: 'SK',
      country: 'CA',
      postalCode: 'S7L 7L1',
      timezone: 'America/Regina',
    },
    formattedAddress: {
      firstLine: '2605 Airport Road',
      secondLine: 'Saskatoon, SK, S7L 7L1, CA',
    },
  },
  {
    code: 'YWG',
    name: 'Winnipeg International Airport',
    address: {
      line1: '2019 Sargent Ave',
      line2: 'Unit 10',
      city: 'Winnipeg',
      province: 'MB',
      country: 'CA',
      postalCode: 'R3H 0E1',
      timezone: 'America/Winnipeg',
    },
    formattedAddress: {
      firstLine: 'Unit 10 2019 Sargent Ave',
      secondLine: 'Winnipeg, MB, R3H 0E1, CA',
    },
  },
  {
    code: 'YYG',
    name: 'Charlottetown Airport',
    address: {
      line1: '250 Maple Hills Avenue',
      line2: 'Suite 132',
      city: 'Charlottetown',
      province: 'PE',
      country: 'CA',
      postalCode: 'C1C 1N2',
      timezone: 'America/Halifax',
    },
    formattedAddress: {
      firstLine: 'Suite 132 250 Maple Hills Avenue',
      secondLine: 'Charlottetown, PE, C1C 1N2, CA',
    },
  },
  {
    code: 'YFC',
    name: 'Fredericton International Airport',
    address: {
      line1: '2570 Route 102 Highway',
      line2: '',
      city: 'Lincoln',
      province: 'NB',
      country: 'CA',
      postalCode: 'E3B 9G1',
      timezone: 'America/Moncton',
    },
    formattedAddress: {
      firstLine: '2570 Route 102 Highway',
      secondLine: 'Lincoln, NB, E3B 9G1, CA',
    },
  },
  {
    code: 'YHZ',
    name: 'Halifax Stanfield International Airport',
    address: {
      line1: '619 Barnes Drive',
      line2: '',
      city: 'Goffs',
      province: 'NS',
      country: 'CA',
      postalCode: 'B2T 1K3',
      timezone: 'America/Halifax',
    },
    formattedAddress: {
      firstLine: '619 Barnes Drive',
      secondLine: 'Goffs, NS, B2T 1K3, CA',
    },
  },
  {
    code: 'YSJ',
    name: 'Saint John Airport',
    address: {
      line1: '4180 Loch Lomond Road',
      line2: '',
      city: 'Saint John',
      province: 'NB',
      country: 'CA',
      postalCode: 'E2N 1L7',
      timezone: 'America/Moncton',
    },
    formattedAddress: {
      firstLine: '4180 Loch Lomond Road',
      secondLine: 'Saint John, NB, E2N 1L7, CA',
    },
  },
  {
    code: 'ZBF',
    name: 'Bathurst Regional Airport',
    address: {
      line1: '640 Chaleur Street',
      line2: '',
      city: 'Bathurst',
      province: 'NB',
      country: 'CA',
      postalCode: 'E2A 4K7',
      timezone: 'America/Moncton',
    },
    formattedAddress: {
      firstLine: '640 Chaleur Street',
      secondLine: 'Bathurst, NB, E2A 4K7, CA',
    },
  },
  {
    code: 'YQY',
    name: 'J.A. Douglas McCurdy Sydney Airport',
    address: {
      line1: '280 Silver Dart Way',
      line2: '',
      city: 'Reserve Mines',
      province: 'NS',
      country: 'CA',
      postalCode: 'B1M 1B8',
      timezone: 'America/Glace_Bay',
    },
    formattedAddress: {
      firstLine: '280 Silver Dart Way',
      secondLine: 'Reserve Mines, NS, B1M 1B8, CA',
    },
  },
  {
    code: 'YDF',
    name: 'Deer Lake Regional Airport',
    address: {
      line1: '1 Airport Road',
      line2: '',
      city: 'Deer Lake',
      province: 'NL',
      country: 'CA',
      postalCode: 'A8A 1A3',
      timezone: 'America/St_Johns',
    },
    formattedAddress: {
      firstLine: '1 Airport Road',
      secondLine: 'Deer Lake, NL, A8A 1A3, CA',
    },
  },
  {
    code: 'YQX',
    name: 'Gander International Airport',
    address: {
      line1: '1000 James Blvd',
      line2: '',
      city: 'Gander',
      province: 'NL',
      country: 'CA',
      postalCode: 'A1V 1W8',
      timezone: 'America/St_Johns',
    },
    formattedAddress: {
      firstLine: '1000 James Blvd',
      secondLine: 'Gander, NL, A1V 1W8, CA',
    },
  },
  {
    code: 'YYT',
    name: "St. John's International Airport",
    address: {
      line1: '114 Airport Service Road',
      line2: '',
      city: "St. John's",
      province: 'NL',
      country: 'CA',
      postalCode: 'A1A 0H6',
      timezone: 'America/St_Johns',
    },
    formattedAddress: {
      firstLine: '114 Airport Service Road',
      secondLine: "St. John's, NL, A1A 0H6, CA",
    },
  },
];

export const DefaultTimezone = 'America/Toronto';

export const ProvinceList = [
  { id: 'AB', text: 'Alberta' },
  { id: 'BC', text: 'British Columbia' },
  { id: 'MB', text: 'Manitoba' },
  { id: 'NB', text: 'New Brunswick' },
  { id: 'NL', text: 'Newfoundland and Labrador' },
  { id: 'NT', text: 'Northwest Territories' },
  { id: 'NS', text: 'Nova Scotia' },
  { id: 'NU', text: 'Nunavut' },
  { id: 'ON', text: 'Ontario' },
  { id: 'PE', text: 'Prince Edward Island' },
  { id: 'QC', text: 'Quebec' },
  { id: 'SK', text: 'Saskatchewan' },
  { id: 'YT', text: 'Yukon' },
];

export const SupportedReconProvideItems = [
  {
    id: SupportedReconProvider.FREIGHT_AIR_CANADA,
    value: SupportedReconProvider.FREIGHT_AIR_CANADA,
    text: ShippingProviderNames.FREIGHT_AIR_CANADA,
  },
  {
    id: SupportedReconProvider.PUROLATOR,
    value: SupportedReconProvider.PUROLATOR,
    text: ShippingProviderNames.PUROLATOR,
  },
  {
    id: SupportedReconProvider.DHL,
    value: SupportedReconProvider.DHL,
    text: ShippingProviderNames.DHL,
  },
  {
    id: SupportedReconProvider.GLS,
    value: SupportedReconProvider.GLS,
    text: ShippingProviderNames.GLS,
  },
  {
    id: SupportedReconProvider.NATIONEX,
    value: SupportedReconProvider.NATIONEX,
    text: ShippingProviderNames.NATIONEX,
  },
  {
    id: SupportedReconProvider.LIVRAPIDE,
    value: SupportedReconProvider.LIVRAPIDE,
    text: ShippingProviderNames.LIVRAPIDE,
  },
  {
    id: SupportedReconProvider.CANPAR,
    value: SupportedReconProvider.CANPAR,
    text: ShippingProviderNames.CANPAR,
  },
  {
    id: SupportedReconProvider.FEDEX,
    value: SupportedReconProvider.FEDEX,
    text: ShippingProviderNames.FEDEX,
  },
  {
    id: SupportedReconProvider.CANADA_POST,
    value: SupportedReconProvider.CANADA_POST,
    text: ShippingProviderNames.CANADA_POST,
  },
  {
    id: SupportedReconProvider.CANADA_POST_3PL,
    value: SupportedReconProvider.CANADA_POST_3PL,
    text: ShippingProviderNames.CANADA_POST_3PL,
  },
  {
    id: SupportedReconProvider.CHASSEURS_COURRIER,
    value: SupportedReconProvider.CHASSEURS_COURRIER,
    text: ShippingProviderNames.CHASSEURS_COURRIER,
  },
  {
    id: SupportedReconProvider.UNIUNI,
    value: SupportedReconProvider.UNIUNI,
    text: ShippingProviderNames.UNIUNI,
  },
  {
    id: SupportedReconProvider.FLASHBOX,
    value: SupportedReconProvider.FLASHBOX,
    text: ShippingProviderNames.FLASHBOX,
  },
  {
    id: SupportedReconProvider.MULTILEG,
    value: SupportedReconProvider.MULTILEG,
    text: ShippingProviderNames.MULTILEG,
  },
  {
    id: SupportedReconProvider.INTELCOM_MULTI_LEG,
    value: SupportedReconProvider.INTELCOM_MULTI_LEG,
    text: ShippingProviderNames.INTELCOM_MULTI_LEG,
  },
  {
    id: SupportedReconProvider.UNIUNI_MULTI_LEG,
    value: SupportedReconProvider.UNIUNI_MULTI_LEG,
    text: ShippingProviderNames.UNIUNI_MULTI_LEG,
  },
  {
    id: SupportedReconProvider.POSTNL_UNIUNI,
    value: SupportedReconProvider.POSTNL_UNIUNI,
    text: ShippingProviderNames.POSTNL_UNIUNI,
  },
  {
    id: SupportedReconProvider.UPS,
    value: SupportedReconProvider.UPS,
    text: ShippingProviderNames.UPS,
  },
  {
    id: SupportedReconProvider.ICS_COURIER,
    value: SupportedReconProvider.ICS_COURIER,
    text: ShippingProviderNames.ICS_COURIER,
  },
  {
    id: SupportedReconProvider.DELIVRO,
    value: SupportedReconProvider.DELIVRO,
    text: ShippingProviderNames.DELIVRO,
  },
  {
    id: SupportedReconProvider.DAYROSS,
    value: SupportedReconProvider.DAYROSS,
    text: ShippingProviderNames.DAYROSS,
  },
  {
    id: SupportedReconProvider.LOOMIS_EXPRESS,
    value: SupportedReconProvider.LOOMIS_EXPRESS,
    text: ShippingProviderNames.LOOMIS_EXPRESS,
  },
  {
    id: SupportedReconProvider.UPIC,
    value: SupportedReconProvider.UPIC,
    text: InsuranceProviderNames.UPIC,
  },
  {
    id: SupportedReconProvider.MARSH,
    value: SupportedReconProvider.MARSH,
    text: InsuranceProviderNames.MARSH,
  },
  {
    id: SupportedReconProvider.FREIGHT_GLS,
    value: SupportedReconProvider.FREIGHT_GLS,
    text: ShippingProviderNames.FREIGHT_GLS,
  },
  {
    id: SupportedReconProvider.CHRONO_EXPRESS,
    value: SupportedReconProvider.CHRONO_EXPRESS,
    text: ShippingProviderNames.CHRONO_EXPRESS,
  },
  {
    id: SupportedReconProvider.UBER,
    value: SupportedReconProvider.UBER,
    text: ShippingProviderNames.UBER,
  },
];

export const ReconProviderItems = [
  {
    id: ShippingProviders.FREIGHT_AIR_CANADA,
    value: ShippingProviders.FREIGHT_AIR_CANADA,
    text: ShippingProviderNames.FREIGHT_AIR_CANADA,
  },
  {
    id: ShippingProviders.PUROLATOR,
    value: ShippingProviders.PUROLATOR,
    text: ShippingProviderNames.PUROLATOR,
  },
  { id: ShippingProviders.DHL, value: ShippingProviders.DHL, text: ShippingProviderNames.DHL },
  { id: ShippingProviders.GLS, value: ShippingProviders.GLS, text: ShippingProviderNames.GLS },
  {
    id: ShippingProviders.NATIONEX,
    value: ShippingProviders.NATIONEX,
    text: ShippingProviderNames.NATIONEX,
  },
  {
    id: ShippingProviders.CANPAR,
    value: ShippingProviders.CANPAR,
    text: ShippingProviderNames.CANPAR,
  },
  {
    id: ShippingProviders.FEDEX,
    value: ShippingProviders.FEDEX,
    text: ShippingProviderNames.FEDEX,
  },
  { id: ShippingProviders.RIVO, value: ShippingProviders.RIVO, text: ShippingProviderNames.AIR_CANADA },
  {
    id: ShippingProviders.MULTILEG,
    value: ShippingProviders.MULTILEG,
    text: ShippingProviderNames.MULTILEG,
  },
  {
    id: ShippingProviders.CANADA_POST,
    value: ShippingProviders.CANADA_POST,
    text: ShippingProviderNames.CANADA_POST,
  },
  {
    id: ShippingProviders.CHASSEURS_COURRIER,
    value: ShippingProviders.CHASSEURS_COURRIER,
    text: ShippingProviderNames.CHASSEURS_COURRIER,
  },
  {
    id: ShippingProviders.UNIUNI,
    value: ShippingProviders.UNIUNI,
    text: ShippingProviderNames.UNIUNI,
  },
  {
    id: ShippingProviders.FLASHBOX,
    value: ShippingProviders.FLASHBOX,
    text: ShippingProviderNames.FLASHBOX,
  },
  { id: ShippingProviders.UPS, value: ShippingProviders.UPS, text: ShippingProviderNames.UPS },
  {
    id: ShippingProviders.ICS_COURIER,
    value: ShippingProviders.ICS_COURIER,
    text: ShippingProviderNames.ICS_COURIER,
  },
  { id: ShippingProviders.LIVRAPIDE, value: ShippingProviders.LIVRAPIDE, text: ShippingProviderNames.LIVRAPIDE },
  {
    id: ShippingProviders.CANADA_POST_3PL,
    value: ShippingProviders.CANADA_POST_3PL,
    text: ShippingProviderNames.CANADA_POST_3PL,
  },
  { id: ShippingProviders.DELIVRO, value: ShippingProviders.DELIVRO, text: ShippingProviderNames.DELIVRO },
  { id: ShippingProviders.DAYROSS, value: ShippingProviders.DAYROSS, text: ShippingProviderNames.DAYROSS },
  {
    id: ShippingProviders.CHRONO_EXPRESS,
    value: ShippingProviders.CHRONO_EXPRESS,
    text: ShippingProviderNames.CHRONO_EXPRESS,
  },
  {
    id: ShippingProviders.LOOMIS_EXPRESS,
    value: ShippingProviders.LOOMIS_EXPRESS,
    text: ShippingProviderNames.LOOMIS_EXPRESS,
  },
  {
    id: ShippingProviders.FREIGHT_GLS,
    value: ShippingProviders.FREIGHT_GLS,
    text: ShippingProviderNames.FREIGHT_GLS,
  },
  {
    id: ShippingProviders.UBER,
    value: ShippingProviders.UBER,
    text: ShippingProviderNames.UBER,
  },
  {
    id: ShippingProviders.CHRONO_EXPRESS,
    value: ShippingProviders.CHRONO_EXPRESS,
    text: ShippingProviderNames.CHRONO_EXPRESS,
  },
  {
    id: InsuranceProviders.UPIC,
    value: InsuranceProviders.UPIC,
    text: InsuranceProviderNames.UPIC,
  },
  {
    id: InsuranceProviders.MARSH,
    value: InsuranceProviders.MARSH,
    text: InsuranceProviderNames.MARSH,
  },
];

export const NavItems: sidenavItems[] = [
  {
    routerLink: 'users',
    iconType: 'icons',
    icon: 'person',
    iconClass: 'icon-user',
    title: 'Users',
    active: false,
    scope: [AdminScopes.VIEW_USERS],
  },
  {
    routerLink: 'shipments',
    iconType: 'icons',
    icon: 'send',
    iconClass: 'icon-ship',
    title: 'Shipments',
    active: false,
    scope: [AdminScopes.VIEW_SHIPMENTS],
  },
  {
    routerLink: 'shipments-stream',
    iconType: 'icons',
    icon: 'send',
    iconClass: 'icon-chevron-w-up',
    title: 'Shipments Stream',
    active: false,
    scope: [AdminScopes.VIEW_SHIPMENTS],
    preventScope: [AdminScopes.LIMIT_RIVO, AdminScopes.LIMIT_UNIUNI],
  },
  {
    routerLink: 'awb-labels',
    iconType: 'symbols',
    icon: 'package',
    title: 'AWB Labels',
    active: false,
    scope: [AdminScopes.VIEW_AWB_LABELS],
  },
  {
    routerLink: 'awb-pickups',
    iconType: 'symbols',
    icon: 'parking_valet',
    title: 'AWB Pickups',
    active: false,
    scope: [AdminScopes.VIEW_AWB_PICKUPS],
  },
  {
    routerLink: 'scan-events',
    iconType: 'symbols',
    icon: 'document_scanner',
    title: 'Scan Events',
    active: false,
    scope: [AdminScopes.VIEW_SCAN_EVENTS],
  },
  {
    routerLink: 'reports',
    iconType: 'icons',
    icon: 'query_stats',
    title: 'Report',
    active: false,
    scope: [AdminScopes.VIEW_REPORTS],
  },
  {
    routerLink: 'otp',
    iconType: 'symbols',
    icon: 'delivery_truck_speed',
    title: 'OTP',
    pageTitle: 'On-Time Performance Dashboard',
    active: false,
    scope: [AdminScopes.VIEW_OTP],
  },
  {
    routerLink: 'dashboard',
    iconType: 'icons',
    icon: 'space_dashboard',
    title: 'Dashboard',
    active: false,
    scope: [AdminScopes.VIEW_DASHBOARD],
  },
  {
    routerLink: 'invoices',
    icon: 'receipt_long',
    title: 'Invoices',
    active: false,
    scope: [AdminScopes.VIEW_INVOICES],
  },
  {
    routerLink: 'couriers',
    iconType: 'icons',
    icon: 'truck',
    iconClass: 'icon-truck',
    title: 'Couriers',
    active: false,
    scope: [AdminScopes.VIEW_COURIERS],
  },
  {
    routerLink: 'platforms',
    icon: 'storefront',
    title: 'Platforms',
    active: false,
    scope: [AdminScopes.VIEW_PLATFORMS],
  },
  {
    routerLink: 'reconciliation',
    iconType: 'icons',
    icon: 'icon-bill-dollar',
    iconClass: 'icon-bill-dollar',
    title: 'Reconciliation',
    active: false,
    scope: [AdminScopes.VIEW_RECONCILIATION],
  },
  {
    routerLink: 'unknown-tracking',
    iconType: 'icons',
    icon: 'icon-no-docs',
    iconClass: 'icon-no-docs',
    title: 'Unknown Tracking',
    active: false,
    scope: [AdminScopes.VIEW_UNKNOWN_TRACKING],
  },
  {
    routerLink: 'unbillable-shipment',
    iconType: 'icons',
    icon: 'icon-no',
    iconClass: 'icon-no',
    title: 'Do not bill',
    active: false,
    scope: [AdminScopes.VIEW_UNBILLABLE_SHIPMENTS],
  },
  {
    routerLink: 'finance',
    icon: 'credit_score',
    title: 'Finance',
    active: false,
    scope: [AdminScopes.VIEW_FINANCE],
  },
  {
    routerLink: 'claims',
    icon: 'confirmation_number',
    title: 'Claims',
    active: false,
    scope: [AdminScopes.VIEW_CLAIMS],
  },
  {
    routerLink: 'site-tours',
    iconType: 'icons',
    icon: 'icon-redirects',
    iconClass: 'icon-redirects',
    title: 'Site Tours',
    active: false,
    scope: [AdminScopes.VIEW_SITE_TOURS],
  },
  {
    routerLink: 'fraud-detection',
    iconType: 'symbols',
    icon: 'detection_and_zone_off',
    title: 'Fraud Detection',
    active: false,
    scope: [AdminScopes.VIEW_FRAUD_DETECTION],
  },
  {
    routerLink: 'sso-connections',
    icon: 'vpn_key',
    title: 'SSO Connections',
    active: false,
    scope: [AdminScopes.VIEW_SSO_CONNECTIONS],
  },
  {
    routerLink: 'permissions',
    icon: 'manage_accounts',
    title: 'Permissions',
    active: false,
    scope: [AdminScopes.VIEW_PERMISSIONS],
  },
  {
    routerLink: 'configuration',
    iconType: 'icons',
    icon: 'config',
    iconClass: 'icon-config',
    title: 'Configuration',
    active: false,
    scope: [AdminScopes.VIEW_CONFIGURATION],
  },
  {
    routerLink: 'rating-tool',
    iconType: 'icons',
    icon: 'config',
    iconClass: 'icon-scale',
    title: 'Rating Tool',
    active: false,
    scope: [AdminScopes.VIEW_RATING_TOOL],
  },
  // {
  //   routerLink: 'service-builder',
  //   icon: 'widgets',
  //   title: 'Service builder',
  //   active: false,
  //   scope: [AdminScopes.VIEW_SERVICE_BUILDER],
  // },
  // {
  //   routerLink: 'notifications',
  //   icon: 'notifications',
  //   title: 'Notifications',
  //   active: false,
  //   scope: [AdminScopes.VIEW_NOTIFICATIONS],
  // },
  // {
  //   routerLink: 'cancellations',
  //   icon: 'error_outlined',
  //   title: 'Cancellations',
  //   active: false,
  //   scope: [AdminScopes.VIEW_CANCELLATIONS],
  // },
  // {
  //   routerLink: 'api-keys',
  //   icon: 'api',
  //   title: 'API Keys',
  //   active: false,
  //   scope: [AdminScopes.VIEW_API_KEYS],
  // },
];

// ==================== Scan Events Constants ====================

/**
 * Scan events airports - all supported airports for scan event reports.
 * Used as fallback when API response doesn't provide available locations.
 */
export const ScanEventsAirports = SupportedAirports.map((airport) => ({
  code: airport.code,
  name: airport.name,
  timezone: airport.address.timezone,
}));

/**
 * Airport codes for scan events - simple array for dropdown options.
 */
export const ScanEventsAirportCodes = ScanEventsAirports.map((a) => a.code);

/**
 * Pickup providers for scan events.
 * Currently only one provider exists - add more here when available.
 * NOTE: Backend ignores pickupProviders filter until more than one provider exists.
 */
export const PickupProviders = [{ id: 'appleexpress', name: 'Apple Express' }];

/**
 * Maximum date range for scan event queries (365 days).
 */
export const MAX_SCAN_EVENTS_DATE_RANGE_DAYS = 365;

/**
 * Default display timezone (fallback when browser timezone unavailable).
 */
export const DEFAULT_DISPLAY_TIMEZONE = 'America/Toronto';

/**
 * Pagination defaults for pickup scans.
 */
export const PICKUP_SCANS_DEFAULT_PAGE_SIZE = 20;
export const PICKUP_SCANS_MAX_PAGE_SIZE = 100;
